var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-wrapper" },
    [
      _c("modal-header", {
        attrs: {
          title: "Generative AI news summary",
          "on-modal-close": _vm.close
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "homebase-modal-body pb-2 px-5" }, [
        _vm.isLoading
          ? _c(
              "div",
              { staticClass: "pt-4" },
              [
                _c("div", { staticClass: "generating-msg" }, [
                  _vm._v("Generating...")
                ]),
                _vm._v(" "),
                _c(
                  "vue-content-loading",
                  {
                    staticClass: "mb-1 search-loading-component",
                    attrs: {
                      width: 300,
                      height: 60,
                      preserveAspectRatio: "none"
                    }
                  },
                  [
                    _c("rect", {
                      attrs: {
                        x: "0",
                        y: "10",
                        rx: "4",
                        ry: "4",
                        width: "300",
                        height: "6"
                      }
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "0",
                        y: "30",
                        rx: "4",
                        ry: "4",
                        width: "300",
                        height: "6"
                      }
                    })
                  ]
                )
              ],
              1
            )
          : _c("div", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 pb-3" }, [
                  _vm.isErrored
                    ? _c("div", { staticClass: "alert alert-error mt-3" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                            "\n          "
                        )
                      ])
                    : _c("div", { staticClass: "pt-4 pb-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column-reverse flex-sm-row justify-content-sm-between align-items-sm-end"
                          },
                          [
                            _c("div", { staticClass: "content-title pb-2" }, [
                              _vm._v("Top stories at Autodesk")
                            ]),
                            _vm._v(" "),
                            _vm.isFullContentLoaded
                              ? _c("div", { staticClass: "pb-3" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "share-text d-inline-block mr-1"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.shareText))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "share-icon d-inline-block"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "d-flex w-100 h-100 justify-content-center align-items-center",
                                          attrs: { href: _vm.mailToLink },
                                          on: { click: _vm.handleMailToClick }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: ["fas", "envelope"] }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "share-icon d-inline-block"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "d-flex w-100 h-100 justify-content-center align-items-center",
                                          on: { click: _vm.handleCopyLink }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: ["fas", "link"] }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "news-summary" }, [
                          _vm.isFullContentLoaded
                            ? _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.handleContentClick($event)
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.newsSummary)
                                    }
                                  })
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "typed-container",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleContentClick($event)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "static-content" }, [
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.startTyping,
                                          expression: "startTyping"
                                        }
                                      ],
                                      domProps: {
                                        innerHTML: _vm._s(_vm.newsSummary)
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "typed-content" }, [
                                    _c(
                                      "div",
                                      { attrs: { id: "typed-strings" } },
                                      [
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.startTyping,
                                              expression: "startTyping"
                                            }
                                          ],
                                          domProps: {
                                            innerHTML: _vm._s(_vm.newsSummary)
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { attrs: { id: "typed" } })
                                  ])
                                ]
                              )
                        ])
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "feedback-wrapper d-flex justify-content-end",
                      on: {
                        click: function($event) {
                          return _vm.handleFeedbackClick()
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["far", "comments"], size: "lg" }
                      }),
                      _vm._v(" "),
                      _c("strong", { staticClass: "ml-2" }, [
                        _vm._v("Feedback")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tooltip-wrapper d-flex justify-content-end"
                    },
                    [
                      _vm.showTooltip
                        ? _c("div", { staticClass: "news-summary-tooltip" }, [
                            _vm._v(
                              "\n              Generative AI summarizes Autodesk's top stories using artificial\n              intelligence. This experimental experience may provide\n              inaccurate or unexpected results. Your use of and feedback on\n              generative AI summaries will help improve the experience.\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tooltip-text pt-1",
                          on: {
                            mouseover: _vm.toggleTooltip,
                            mouseleave: _vm.toggleTooltip
                          }
                        },
                        [
                          _vm._v(
                            "\n              What is a generative AI news summary?\n            "
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-587fb033", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587fb033","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/modals/SummarizeNewsModal.vue
// module id = null
// module chunks = 